import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-center items-center", _ctx.store.state.base.responsive.isSM ? 'search-box':''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_autocomplete, {
        id: "video-search-box",
        modelValue: _ctx.search_word,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_word) = $event)),
        "fetch-suggestions": _ctx.querySearch,
        class: "inline-input w-screen md:w-60 lg:w-80 md:pr-1 pr-10",
        "popper-class": _ctx.store.state.base.responsive.isSM ? 'my-autocomplete-mobile' : 'my-autocomplete-pc',
        placeholder: "動画を検索",
        onFocus: _ctx.onFocus,
        onKeypress: _withKeys(_withModifiers(_ctx.onSearch, ["prevent","exact"]), ["enter"]),
        type: "search",
        ref: "focusSearch"
      }, _createSlots({
        default: _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: "truncate",
            onClick: ($event: any) => (_ctx.onSuggestSearch(item.value))
          }, _toDisplayString(item.value), 9, _hoisted_2)
        ]),
        _: 2
      }, [
        (!_ctx.store.state.base.responsive.isSM)
          ? {
              name: "append",
              fn: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _ctx.onSearch,
                  icon: _ctx.Search
                }, null, 8, ["onClick", "icon"])
              ])
            }
          : undefined
      ]), 1032, ["modelValue", "fetch-suggestions", "popper-class", "onFocus", "onKeypress"])
    ])
  ], 2))
}